import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/websites/show.vue'

export default class extends Controller {
  static values = {
    websiteId: String,
    businessId: String
  }

  connect() {
    this.vue = createApp(App, {
      websiteId: this.websiteIdValue,
      businessId: this.businessIdValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
